import { render } from "./Oases.vue?vue&type=template&id=0c80c40c"
import script from "./Oases.vue?vue&type=script&lang=js"
export * from "./Oases.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/villageOverview/Oases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c80c40c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c80c40c', __exports__)) {
    api.reload('0c80c40c', __exports__)
  }
  
  module.hot.accept("./Oases.vue?vue&type=template&id=0c80c40c", () => {
    api.rerender('0c80c40c', render)
  })

}


export default __exports__